import { t } from 'i18next';
import { useIssueCommandMutation } from '../../../features/courses/coursesApi';
import { Enums } from '../../../shared';
import { notification } from 'antd';
import React from 'react';

const getMenuActions = (submission) => {
    const [issueCommand, {}] = useIssueCommandMutation();

    return [
        {
            key: 'open',
            label: (
                <a href={submission.file_link} target="_blank">
                    {t('open')}
                </a>
            ),
        },
        {
            key: 'approve',
            label: t('approve'),
            onClick: () => {
                const command = {
                    type: Enums.COMMAND_TYPES.APPROVE_SUBMISSION,
                    submissionId: submission.id,
                };

                issueCommand({ command })
                    .unwrap()
                    .then((res) => {
                        notification.info({
                            message: t('Submission approved'),
                            duration: 2,
                        });
                    })
                    .catch((err) => {
                        notification.error({
                            message: t('Submission approval failed'),
                            duration: 2,
                        });
                    });
            },
        },
        {
            key: 'reject',
            label: t('reject'),
            onClick: () => {
                const command = {
                    type: Enums.COMMAND_TYPES.REJECT_SUBMISSION,
                    submissionId: submission.id,
                };
                issueCommand({ command })
                    .unwrap()
                    .then((res) => {
                        notification.info({
                            message: t('Submission rejected'),
                            duration: 2,
                        });
                    })
                    .catch((err) => {
                        notification.error({
                            message: t('Submission rejection failed'),
                            duration: 2,
                        });
                    });
            },
        },
    ];
};

export default getMenuActions;
